import { useLocation } from 'react-router-dom';

import { useEffect, useRef, useState } from 'react';

/**
 * Hook to manage route transition loading states
 * Shows loading immediately when route changes start
 */
export function useRouteTransition() {
  const location = useLocation();
  const pathname = location.pathname;
  const [isTransitioning, setIsTransitioning] = useState(false);
  const previousPathRef = useRef(pathname);

  // Detect when pathname actually changes
  useEffect(() => {
    if (pathname !== previousPathRef.current) {
      // Wrap setState in setTimeout to avoid direct state setting in effect
      const timer = setTimeout(() => {
        setIsTransitioning(prev => {
          if (prev) return false;
          return prev;
        });
      }, 0);
      previousPathRef.current = pathname;
      return () => clearTimeout(timer);
    }
  }, [pathname]);

  // Function to start a transition
  const startTransition = (href: string) => {
    if (href !== pathname) {
      setIsTransitioning(true);
    }
  };

  return {
    isTransitioning,
    startTransition,
    currentPath: pathname,
  };
}
